import { Modal } from "bootstrap";
import "select2";

$(function () {
    const modalEl = document.getElementById("ChangeContratModal");
    if (!modalEl) return;

    const contrat_selection_modal: Modal = Modal.getOrCreateInstance(modalEl);
    $("#changeContrat").on("click", function () {
        if (window["user"] && window["user"].contrats.length > 1) {
            contrat_selection_modal.show();
        }
    });

    $("#ChangeContratModal").on("shown.bs.modal", function () {
        $("#selectContrat").select2("open");
    });

    $("#selectContrat").on("change", function () {
        contrat_selection_modal.show();
        window.location.href = "/admin/contrats/select/" + $("#selectContrat").val();
    });

    $("#selectContrat").select2({
        dropdownParent: "#ChangeContratModal",
        width: "100%",
    });
});
